import { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import clsx from "clsx";
// hooks
import useMenuItems from "@/hooks/useMenuItems";
// components
import RMDRLink from "@/components/RMDRLink";
// utilities
import { 
    menuNameDescriptionLanguageVersion, 
    metaDataLanguageVersion,
    redirectUrl 
} from "@/utilities/LanguageVersionSelectorShortcut";
import MenuComposer from "@/utilities/MenuComposer";
// types
import { TMainPageLayoutV3 } from "../type";
import TMenu from "@/cms/types/TMenu";
import TClientMenuItemList from "@/cms/types/TClientMenuItemList";


const MobileMenu = ( props:{payload:TMenu[], webApplicationLanguageISOCode:string} ) => {
    const location = useLocation();

    const [ activeMenu, setActiveMenu ] = useState<string[]>([]);

    return (
        <>
            {
                props.payload?.map((item, index) => {
                    const languageVersion = menuNameDescriptionLanguageVersion(item.languageVersions);
                    if ( !languageVersion ) return null;
                    let _redirectUrl = redirectUrl(item.languageVersions)?.value;

                    if ( item.layouts?.[0]?.layoutName === "MN_001" ) _redirectUrl = `/${props.webApplicationLanguageISOCode}`;
                    else if ( item.layouts?.[0]?.layoutName === "MN_002" ) {
                        const redirectPath = metaDataLanguageVersion("redirectPath", item.languageVersions);
                        const redirectUrl = metaDataLanguageVersion("redirectUrl", item.languageVersions);
                        if ( redirectPath ) _redirectUrl = `/${props.webApplicationLanguageISOCode}${redirectPath}`;
                        else if ( redirectUrl ) _redirectUrl = redirectUrl;
                    }

                    return (
                        <li key={item.id} className={clsx({"active":location.pathname === languageVersion.contentRouteNavigationURL},{"has-dropdown": item.items && item.items?.length > 0})}>
                            <RMDRLink
                                text={languageVersion?.name}
                                title={languageVersion?.name}

                                hasNavigationDestination={item.hasDestinationNavigation}

                                navigationURL={languageVersion?.contentRouteNavigationURL}

                                redirectType={item.redirectType}
                                redirectUrl={_redirectUrl}
                                isShowAlways={true}
                                className={clsx("cursor-pointer",{"drop":item.items && item.items.length>0},{ "drop-active":activeMenu.includes(item.id) })}
                                onClick={() => { setActiveMenu((prevProps) => {
                                    if ( prevProps.includes(item.id) ) {
                                        return prevProps.filter((x) => x !== item.id);
                                    } else {
                                        return [...prevProps, item.id]
                                    }
                                }) }}
                                variant="div"
                            />
                            {
                                item.items && item.items.length > 0 && (<ul className={clsx("submenu", { "sub-menu-active":activeMenu.includes(item.id) })}><MobileMenu payload={item.items} webApplicationLanguageISOCode={props.webApplicationLanguageISOCode} /></ul>)
                            }
                        </li>
                    )
                })
            }
        </>
    )
}

const Render = ( props:{ menuItems:TClientMenuItemList[] } ) => {
    console.log("MNPG046.Render: ", props);
    
    const webApplicationLanguageISOCode = useSelector((state:any) => state.CoreStore.languageCode?.payload, shallowEqual);
    let parentMenuItems = props.menuItems.filter((item:any) => item.parentId === null);
    let navigation = MenuComposer(props.menuItems, parentMenuItems);
    
    if ( !navigation ) return null;

    return (
        <div className="mobile-menu fix mb-3 mean-container">
            <div className="mean-bar">
                <nav className="mean-nav mobile-menu">
                    <ul>
                        <MobileMenu payload={navigation} webApplicationLanguageISOCode={webApplicationLanguageISOCode} />
                    </ul>
                </nav>
            </div>
        </div>
    )
}

const RenderOwnContent = ( props:{unqKey:string, contentLayoutName:string} ) => {
    console.log("MNPG046.RenderOwnContent: ", props);
    
    const menuItems = useMenuItems(props.unqKey, props.contentLayoutName);

    if ( !menuItems ) return null;

    return <Render menuItems={menuItems} />

}

const MNPG046 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG046.rendered: ", props);

    if ( !props.template ) return null;

    const unqKey = props.template.id.split("-")[4];
    return (
        <RenderOwnContent unqKey={unqKey} contentLayoutName={props.template.contentLayoutName} />
    )
}

export default MNPG046;
